// extracted by mini-css-extract-plugin
export default {"input-box":"InputSlideToggle_input-box__chh7X","label":"InputSlideToggle_label__Nlk8O"};